export default {
  "zh-CN": {
    eyebrow: "STARLIVE 发现精选",
    recommendation: "偶尔为你推荐一条发现内容",
    heat: "热度 {count}",
    episodeMeta: "更新至 {current} 集 · 共 {total} 集",
    gameMeta: "StarLive 小游戏",
    types: { drama: "短剧", novel: "小说", music: "音乐", game: "小游戏" },
    actions: { drama: "查看短剧", novel: "开始阅读", music: "立即聆听", game: "开始游玩" }
  },
  "en-US": {
    eyebrow: "STARLIVE DISCOVERY PICK",
    recommendation: "An occasional pick from Discover",
    heat: "Popularity {count}",
    episodeMeta: "Episode {current} of {total}",
    gameMeta: "StarLive mini game",
    types: { drama: "Short drama", novel: "Novel", music: "Music", game: "Mini game" },
    actions: { drama: "View drama", novel: "Start reading", music: "Listen now", game: "Play now" }
  },
  "ar-SA": {
    eyebrow: "مختارات STARLIVE",
    recommendation: "اقتراح خفيف من صفحة الاكتشاف",
    heat: "الرواج {count}",
    episodeMeta: "الحلقة {current} من {total}",
    gameMeta: "لعبة StarLive",
    types: { drama: "مسلسل قصير", novel: "رواية", music: "موسيقى", game: "لعبة صغيرة" },
    actions: { drama: "عرض المسلسل", novel: "بدء القراءة", music: "استمع الآن", game: "ابدأ اللعب" }
  }
}
